export interface LendLostRequestCollection {
  id: number // 資料ID
  revision: number
}

export function LendLostRequestCollectionToJSON(
  value: LendLostRequestCollection
): any {
  return {
    id: value.id,
    revision: value.revision
  }
}
